const RELEVANT_ALERTS: BookabilityRule[] = ['moderators_need_calendar', 'moderators_need_calendar_selected'];

export const getCalendarAlertsForUser = (userId: number, bookability?: Bookability): BookabilityRule[] =>
  RELEVANT_ALERTS.filter((rule) => bookability?.[rule]?.[1]?.user_ids?.includes(userId));
